export { default as DislikeIcon } from './DislikeIcon';
